export enum ERROR_MESSAGE_TYPE {
  CUSTOM = 'custom', // { message: string }
  EMAIL = 'email', // {email: true}
  FORMAT = 'format', // {format: {correctFormat: string}}
  IN_RANGE = 'inRange', // {inRange: {nameOfThisControl: string, min: string, max: string}}
  MIN = 'min', // {min: {min: 3, actual: 2}}
  MAX = 'max', // {max: {max: 15, actual: 16}}
  MIN_LENGTH = 'minlength', // {minlength: {requiredLength: 3, actualLength: 2}}
  MAX_LENGTH = 'maxlength', // {maxlength: {requiredLength: 3, actualLength: 2}},
  MAX_NUMBER_SMS = 'maxNumberSms', // {maxNumberSms: {max: 3}},
  MUST_CONTAIN_CONTENT = 'mustContainContent', // {mustContainContent: {nameOfInput: string, mustContainContent: string[], value: any}},
  NOT_EARLIER = 'notEarlier', // {notEarlier: {nameOfThisControl: string, nameOfAnotherControl string, valueOfThisControl: any, valueOfAnotherControl: any}},
  PASSWORD = 'password', // {password: {errorMessage: string, criteria string, value: any}},
  REQUIRED = 'required', // {required: true}
  SAME_VALUE = 'sameValue', // {sameValue: {nameOfThisControl: string, nameOfAnotherControl string, valueOfThisControl: any, valueOfAnotherControl: any}}
}
